import { useCallback, useState } from 'react'

import type { KeyedMedia } from './types'

export const useBulkDownload = (items: KeyedMedia[]) => {
  const [downloading, setDownloading] = useState(false)

  const downloadAll = useCallback(async () => {
    const images = items.filter(
      (item) => item.type !== 'video' && !item.isPlaceholder
    )
    if (images.length === 0) return

    setDownloading(true)
    try {
      const JSZip = (await import('jszip')).default
      const zip = new JSZip()

      await Promise.all(
        images.map(async (item, index) => {
          const url =
            item.urls?.original ?? item.urls?.large ?? item.urls?.medium
          if (!url) return
          try {
            const proxyUrl = `/api/image-proxy?url=${encodeURIComponent(url)}`
            const response = await fetch(proxyUrl)
            if (!response.ok) return
            const blob = await response.blob()
            const ext =
              new URL(url).pathname.split('.').pop()?.split('?')[0] ?? 'jpg'
            zip.file(`photo-${index + 1}.${ext}`, blob)
          } catch {
            // skip any image that fails to fetch
          }
        })
      )

      if (Object.keys(zip.files).length === 0) return
      const blob = await zip.generateAsync({ type: 'blob' })
      const objectUrl = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl
      a.download = 'listing-photos.zip'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(objectUrl)
    } finally {
      setDownloading(false)
    }
  }, [items])

  return { downloading, downloadAll }
}
